/* EON collection page: auto-submit filters, sort, mobile filter drawer, load more. */
(() => {
  document.documentElement.classList.add('js-eon');

  /** @param {HTMLElement} root */
  function init(root) {
    if (root.dataset.eonReady) return;
    root.dataset.eonReady = 'true';
    const sectionId = root.dataset.sectionId;
    const form = root.querySelector('[data-eon-filter-form]');
    const drawer = root.querySelector('[data-eon-drawer]');
    const scrim = root.querySelector('.eon-coll__scrim');
    const openBtn = root.querySelector('[data-eon-open]');
    const mobile = window.matchMedia('(max-width: 820px)');

    // Mobile chip row scrolls sideways: bring the current collection into view.
    const chips = root.querySelector('[data-eon-chips]');
    const activeChip = chips?.querySelector('.is-active');
    if (chips && activeChip instanceof HTMLElement && chips.scrollWidth > chips.clientWidth) {
      chips.scrollLeft = activeChip.offsetLeft - chips.offsetLeft - 16;
    }

    const submit = () => {
      if (!(form instanceof HTMLFormElement)) return;
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(form)) {
        if (typeof value === 'string' && value.trim() !== '') params.append(key, value.trim());
      }
      window.location.href = `${form.action}?${params.toString()}`;
    };

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      submit();
    });
    // Desktop applies each change right away; the mobile drawer waits for "Apply".
    form?.addEventListener('change', (event) => {
      if (mobile.matches) return;
      const target = event.target;
      if (target instanceof HTMLElement && (target.matches('[data-eon-autosubmit]') || target.closest('.eon-coll__price'))) submit();
    });

    root.querySelector('[data-eon-sort]')?.addEventListener('change', (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement)) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    const setDrawer = (open) => {
      drawer?.classList.toggle('is-open', open);
      scrim?.classList.toggle('is-open', open);
      openBtn?.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) drawer?.querySelector('[data-eon-close]')?.focus();
      else openBtn?.focus();
    };
    openBtn?.addEventListener('click', () => setDrawer(true));
    for (const el of root.querySelectorAll('[data-eon-close]')) el.addEventListener('click', () => setDrawer(false));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer?.classList.contains('is-open')) setDrawer(false);
    });

    root.addEventListener('click', async (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-eon-next]') : null;
      if (!(link instanceof HTMLAnchorElement)) return;
      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Loading…';
      try {
        const url = new URL(link.href);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = root.querySelector('[data-eon-grid]');
        for (const item of doc.querySelectorAll('[data-eon-item]')) grid?.append(item);
        const more = doc.querySelector('[data-eon-more]');
        const current = root.querySelector('[data-eon-more]');
        if (more && current) current.replaceWith(more);
      } catch (error) {
        // Fall back to a normal page load.
        window.location.href = link.href;
      }
    });
  }

  const boot = () => document.querySelectorAll('[data-eon-collection]').forEach((el) => init(/** @type {HTMLElement} */ (el)));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
